<template>
    <div>
        <v-col v-if="listRoute" cols="12" class="tabs">
            <h2 class="mt-4">{{ t('spire-ftp::page.title.spire_ftp') }}</h2>
            <div class="tabs-top-actions">
                <div class="top-actions">
                    <div class="action">
                        <v-btn
                            v-if="can('spire-blood-results.download')"
                            color="primary"
                            :loading="loading"
                            rounded
                            small
                            @click="generateReport"
                            >{{ t('spire-ftp::button.generate_reports') }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <v-tabs v-model="tab" show-arrows>
                <v-tab v-for="item in items" :key="item">
                    <div class="tab">
                        {{ item }}
                    </div>
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item v-for="(item, index) in dataTableItems" :key="index">
                    <component
                        :is="item.component"
                        :ref="`grid${index}`"
                        :initial-filters="item.initialFilters"
                        :initial-sort="item.initialSort"
                        :list-route="listRoute"
                        :grid-title="item.title"
                    ></component>
                </v-tab-item>
            </v-tabs-items>
        </v-col>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            items: [t('spire-ftp::tabs.items.linked_samples'), t('spire-ftp::tabs.items.missing_information')],
            dataTableItems: [
                {
                    component: 'spire-blood-linked-results-data-table',
                    title: t('spire-ftp::tabs.items.linked_samples'),
                    initialFilters: { linked: 1 },
                    initialSort: '-created_at',
                },
                {
                    component: 'spire-blood-missing-results-data-table',
                    title: t('spire-ftp::tabs.items.missing_information'),
                    initialFilters: { linked: 0 },
                    initialSort: '-created_at',
                },
            ],
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.spire.tab;
            },
            set(tab) {
                return this.$store.dispatch('spire/setSpireTab', tab);
            },
        },
        listRoute() {
            return this.$store.state.spire.listRoute;
        },
        gridDateTaken() {
            return this.$store.state.data_table.filters.date_taken;
        },
    },
    watch: {
        tab(newTab, oldTab) {
            if (newTab === oldTab) return;
            if (newTab === 0) {
                return this.$store.dispatch('spire/incremetDateTableKeyLinked');
            }
            if (newTab === 1) {
                return this.$store.dispatch('spire/incremetDateTableKeyMissing');
            }
        },
    },
    created() {},
    methods: {
        generateReport() {
            this.loading = true;
            let params = {
                date_taken: this.gridDateTaken,
                linked: this.tab === 0 ? 1 : 0,
            };
            if (!this.gridDateTaken) delete params.date_taken;
            return axios
                .get(route('spire-blood-results.download', params))
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = response.request.responseURL;
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    this.$root.notify('error', t('spire-ftp::grid.generate.report.fail'), error.response.data.error);
                })
                .finally(() => {
                    _.delay(() => {
                        this.loading = false;
                    }, 1000);
                });
        },
    },
};
</script>
